import React from 'react';
import { Popover as AntdPopover, PopoverProps } from 'antd';
const Popover = (props: PopoverProps) => {
  return <AntdPopover {...props} overlayClassName={props.className} />;
};

export default Popover;
